export enum CardFields {
    cardNumber = 'cardNumber',
    expDateMonthYear = 'expDateMonthYear',
    expDateMonth = 'expDateMonth',
    expDateYear = 'expDateYear',
    cvv = 'cvv'
}